import * as React from 'react'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { SwapVert } from '@mui/icons-material'
import { IProcurementPlanItem } from 'types/procurementPlans/procurementPlanItems'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

function Row(props: { row: IProcurementPlanItem; index: number }) {
  const { row, index } = props
  dayjs.locale('az')
  const monthName = dayjs().month(Number(row.announcementMonth)).format('MMMM')
  const { t } = useTranslation()

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell>{row.name}</TableCell>
        <TableCell>{t(row.method)}</TableCell>
        <TableCell>{monthName}</TableCell>
        <TableCell>{row.deliveryAddress}</TableCell>
        <TableCell>
          {row.executionDurationInDays} {t('DAY')}
        </TableCell>
      </TableRow>
    </React.Fragment>
  )
}

type Props = {
  data: IProcurementPlanItem[]
}

export function PurchasePlansDetailTable({ data }: Props) {
  const { t } = useTranslation()
  return (
    <Box sx={{ overflow: 'auto' }}>
      <Box
        sx={{
          width: '100%',
          display: 'table',
          tableLayout: 'fixed',
        }}
      >
        <TableContainer component={Box}>
          <Table
            size="small"
            sx={{
              background: '#fff',
            }}
          >
            <TableHead
              sx={{
                background: '#fff',
              }}
            >
              <TableRow>
                <TableCell align="center">
                  <SwapVert
                    sx={{
                      color: '#8a94a6',
                      fontSize: '22px',
                    }}
                  />
                </TableCell>
                <TableCell>{t('products-sevice-names')}</TableCell>
                <TableCell>{t('procurementMethod')}</TableCell>
                <TableCell>{t('anouncement-month')}</TableCell>
                <TableCell>{t('delivery-address')}</TableCell>
                <TableCell>{t('delivery-time')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => (
                <Row key={row.name} row={row} index={index} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  )
}
